import { IconButton } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { getSelectedAssessmentSelector } from '@redux/tasks/tasksSelector';
import { clearSelectedAssessmentThunk, setPreviewAssessmentIdThunk } from '@redux/tasks/tasksThunks';
import { ReduxState } from '@redux/types';
import { DropDownMenu } from 'components/DropDownMenu/DropDownMenu';
import { DotsThreeIcon } from 'components/Icons';
import { AssessmentMenuOption } from 'containers/Tasks/components/AssessmentArea/AssessmentMenuOption/AssessmentMenuOption';
import style from './SelectedAssessment.scss';

type Props = ConnectedProps<typeof connectRedux>;

const SelectedAssessment: React.FC<Props> = ({ assessment, setPreviewAssessmentId, clearSelectedAssessment }) => {
  if (!assessment) {
    return null;
  }

  return (
    <div className={classNames(style.container, style.marginBottom)}>
      <AssessmentMenuOption option={assessment} />
      <DropDownMenu
        customMenuElement={(onMenuClick) => (
          <IconButton onClick={onMenuClick} size="small">
            <DotsThreeIcon />
          </IconButton>
        )}
        menuItems={[
          {
            text: 'Preview',
            onClick: () => setPreviewAssessmentId(assessment.id)
          },
          {
            text: 'Delete',
            textClassName: style.redText,
            onClick: clearSelectedAssessment
          }
        ]}
      />
    </div>
  );
};

const connectRedux = connect(
  (state: ReduxState) => ({
    assessment: getSelectedAssessmentSelector(state)
  }),
  {
    clearSelectedAssessment: clearSelectedAssessmentThunk,
    setPreviewAssessmentId: setPreviewAssessmentIdThunk
  }
);

export default compose(connectRedux)(SelectedAssessment);
